<template>
  <div></div>
</template>

<script>
export default {
  name: 'Company',

  created() {
    window.scrollTo(0, 0)
  },
}
</script>

<style></style>
